import { BigNumber } from '@ethersproject/bignumber';

import { humanizeBn } from 'tools';

/**
 * Helpers around Spread -> Offset auto-fill.
 * Kept standalone + unit-tested so precision-sensitive math stays stable.
 */
const MIN_DECIMALS = 18; // maintain sub-integer precision even for whole spreads
const MAX_DECIMALS = 30; // keep plenty of room for trading precision without blowing up 256-bit ints

/**
 * Normalize an arbitrary-precision decimal string to BigNumber with dynamic decimals
 * (up to MAX_DECIMALS) so we don't lose significant digits when halving.
 */
const toFixedDecimals = (value: string) => {
  if (!value || isNaN(Number(value))) {
    return { bn: BigNumber.from(0), decimals: 0 };
  }

  const [integerPart, fractionalPartRaw = ''] = value.split('.');
  const decimals = Math.min(Math.max(fractionalPartRaw.length + 1, MIN_DECIMALS), MAX_DECIMALS);
  const fractionalPart = fractionalPartRaw.slice(0, decimals);
  const fractionalPartPadded = fractionalPart.padEnd(decimals, '0');

  return {
    bn: BigNumber.from(`${integerPart}${fractionalPartPadded}`),
    decimals,
  };
};

export const calcHalfSpreadPercentage = (spreadPercentage: string) => {
  const { bn, decimals } = toFixedDecimals(spreadPercentage);
  const half = bn.div(2); // integer division in decimal-scaled space
  return humanizeBn(half, decimals);
};
